import React from "react";
import { NavbarBorrowSystem } from "../../../components/share/NavbarBorrowSystem";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { FormBorrowComponent } from "../../../components/borrowSystem/BorrowForm/FormBorrowComponent";
import { Footer } from "../../../components/share/Footer";

export function FormBorrowContainer() {
  const titleName = "คำขอกู้ยืมเงินกองทุนพัฒนาฝีมือแรงงาน";

  return (
    <div className="page-container bg-landing">
      <NavbarBorrowSystem />
      <HeadTitle title={titleName} />
      <FormBorrowComponent />
      <Footer />
    </div>
  );
}
